export default {
    showLoader() { },
    hideLoader() { },
    isLoading() { }
};
